import React from 'react'
import { Route } from 'react-router-dom'

export function AuthenticatedRoute({ children, isAuthenticated, ...rest }) {
  return <Route {...rest}>{isAuthenticated === true ? children : ''}</Route>
}
